/* eslint-disable no-undef */
export const constants = {
  googleClientId:
    '621453535282-jvuh4g1tihb0padldb54t76ntj7uqis3.apps.googleusercontent.com',
  apiUrl: __DEV__ ? 'http://localhost:8000/api' : 'https://api.redl.ink/api',
  pageLinkPrefix: 'redl.ink/',
};
